import { getEmbeddableGoogleFont, canLoadGoogleFont } from '../util/embedded-google-fonts';

export type WritingSystem = 'latin' | 'greek' | 'cyrillic' | 'arabic' | 'chinese' | 'korean' | 'devanagari' | 'thai';

export type SignatureFont = 'Mrs Saint Delafield' | 'EB Garamond' | 'Neucha' | 'Amiri' | 'Zhi Mang Xing' | 'Nanum Brush Script' | 'Tillana' | 'Itim';

export function getSignatureFont(writingSystem: WritingSystem): SignatureFont {
	// Look up a cursive font to use for the given writing system
	// All come from Google Fonts
	switch (writingSystem) {
		case 'latin': return 'Mrs Saint Delafield';
		case 'greek': return 'EB Garamond';
		case 'cyrillic': return 'Neucha';
		case 'arabic': return 'Amiri';
		case 'chinese': return 'Zhi Mang Xing';
		case 'korean': return 'Nanum Brush Script';
		case 'devanagari': return 'Tillana';
		case 'thai': return 'Itim';
	}
}

export async function loadEmbeddableSignatureFont(font: SignatureFont): Promise<string> {
	if (canLoadGoogleFont()) {
		try {
			return await getEmbeddableGoogleFont(font, 'swap');
		}
		catch (e) {
			if (typeof console !== 'undefined' && console.warn)
				console.warn(e);
		}
	}
}
